import { createSlice } from '@reduxjs/toolkit';
import {
  getProjectDisclaimer,
  setProjectUserAccepted,
  updateProjectDisclaimer,
} from './projectDisclaimerService';

export const initialState = {};

const projectDisclaimersSlice = createSlice({
  name: 'projectDisclaimers',
  initialState,
  reducers: {
    setDisclaimer: (state, action) => ({
      ...state,
      [action.payload.projectId]: {
        ...action.payload.disclaimer,
        isLoading: false,
        error: null,
      },
    }),
    acceptDisclaimer: (state, action) => ({
      ...state,
      [action.payload.projectId]: {
        ...(state[action.payload.projectId] || {}),
        hasAccepted: true,
        error: null,
      },
    }),
    setIsLoadingDisclaimer: (state, action) => ({
      ...state,
      [action.payload.projectId]: {
        ...(state[action.payload.projectId] || {}),
        isLoading: true,
        error: null,
      },
    }),
    setHasErrorDisclaimer: (state, action) => ({
      ...state,
      [action.payload.projectId]: {
        ...(state[action.payload.projectId] || {}),
        isLoading: false,
        error: action.payload.error,
      },
    }),
  },
});
export default projectDisclaimersSlice.reducer;

// Actions
const {
  setDisclaimer,
  acceptDisclaimer,
  setIsLoadingDisclaimer,
  setHasErrorDisclaimer,
} = projectDisclaimersSlice.actions;

export const setProjectDisclaimer = (projectId, disclaimer) =>
  setDisclaimer({ projectId, disclaimer });

export const acceptProjectDisclaimer = (projectId) =>
  acceptDisclaimer({ projectId });

export const setProjectDisclaimerIsLoading = (projectId) =>
  setIsLoadingDisclaimer({ projectId });

export const setProjectDisclaimerHasError = (projectId, error) =>
  setHasErrorDisclaimer({ projectId, error });

// Selectors
export const getProjectDisclaimerSelector = (projectId) => (state) =>
  state.projectDisclaimers[projectId];

export const getProjectDisclaimerErrorSelector = (projectId) => (state) =>
  state.projectDisclaimers[projectId];

// Thunks
export const loadProjectDisclaimerThunk = (projectId) => async (dispatch) => {
  try {
    dispatch(setProjectDisclaimerIsLoading(projectId));
    const disclaimer = await getProjectDisclaimer(projectId);
    dispatch(setProjectDisclaimer(projectId, disclaimer));
    // eslint-disable-next-line no-empty
  } catch (error) {
    dispatch(setProjectDisclaimerHasError(projectId, error));
  }
};

export const acceptProjectDisclaimerThunk = (projectId) => async (dispatch) => {
  try {
    dispatch(acceptProjectDisclaimer(projectId));
    await setProjectUserAccepted(projectId);
    // eslint-disable-next-line no-empty
  } catch (error) {}
};

export const updateProjectDisclaimerThunk =
  (projectId, disclaimerText) => async (dispatch) => {
    try {
      const updatedDisclaimer = await updateProjectDisclaimer(
        projectId,
        disclaimerText
      );
      dispatch(setProjectDisclaimer(projectId, updatedDisclaimer));
      // eslint-disable-next-line no-empty
    } catch (error) {}
  };
